var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimecheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14118_64903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.62352 10.4568C3.13899 10.4568 1.125 8.44277 1.125 5.95824C1.125 3.4737 3.13899 1.45972 5.62352 1.45972C8.10805 1.45972 10.122 3.4737 10.122 5.95824C10.122 8.44277 8.10805 10.4568 5.62352 10.4568ZM5.62352 9.55705C6.57799 9.55705 7.49336 9.17789 8.16827 8.50298C8.84318 7.82807 9.22234 6.9127 9.22234 5.95824C9.22234 5.00377 8.84318 4.0884 8.16827 3.41349C7.49336 2.73858 6.57799 2.35942 5.62352 2.35942C4.66905 2.35942 3.75368 2.73858 3.07877 3.41349C2.40386 4.0884 2.0247 5.00377 2.0247 5.95824C2.0247 6.9127 2.40386 7.82807 3.07877 8.50298C3.75368 9.17789 4.66905 9.55705 5.62352 9.55705ZM6.07337 5.95824H7.87278V6.85794H5.17367V3.70898H6.07337V5.95824Z",
    fill: "#0D458A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14118_64903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.7964,
    height: 10.7964,
    fill: "white",
    transform: "translate(0.220703 0.560303)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimecheck);
export default __webpack_public_path__ + "static/media/timecheck.62ca83bcc4f77efe70a6f439003e1840.svg";
export { ForwardRef as ReactComponent };